<template>
    <s-modal
        :open="open"
        :cancel="true"
        @cancel="$emit('close')"
        title="Réponse des joueurs"
    >
        <s-button icon="cog" label="Configuration" @onclick="modalConfigure=true" theme="is-primary"/>
        <div v-if="!this.tournoi.options.subscribe" style="padding:10px">
            Les joueurs ne peuvent pas s'inscire... Cliquez sur configuration si vous souhaitez que vos joueurs puissent s'incrire eux mêmes
        </div>
        <div class="listMembresState" v-if="this.subscribe">
            <div v-for="joueur in joueursSortedByEmail" :class="'ligne ' + joueurClass(joueur)">
                <div class="nomprenom">{{joueur.nom}} {{joueur.prenom}}</div>
                <div class="email" v-if="joueurClass(joueur)!='pasEmail'"> {{joueur.email}} {{joueur.emailParent}}</div>
                <div class="email" v-if="joueurClass(joueur)=='pasEmail'"> aucun email renseigné</div>
                <div class="state"> 
                    
                            <span v-if="joueur.absent">
                                Absent
                            </span>
                            <span v-if="joueur.confirmed">
                                Présent
                            </span>
                            <span v-if="!joueur.confirmed && !joueur.absent && joueurClass(joueur)!='pasEmail'">
                            En attente...
                            
                            </span>
                        
                </div>
                <div class="rappel" v-if="!joueur.confirmed && !joueur.absent && joueurClass(joueur)!='pasEmail'"> 
                    <s-button mode="V" label="" @onclick="joueurSelected=joueur;modalConfirmMail=true" theme="is-info is-small" icon="paper-plane"/>
                </div>
                
            </div>
        </div>
        <div class="buttonReinit"  v-if="this.subscribe">
        Vous pouvez réinitialiser les préinscriptions en fonction des réponses de vos joueurs :<br/>
        <s-button @onclick="presinscriptionReinit" icon="sync" label="Réinitialisation" theme="is-primary"/>
        </div>
        <s-confirm
            :open="modalConfirmMail"
            @no="modalConfirmMail=false"
            @yes="sendMail(joueurSelected, true)"
        >
            Souhaitez vous envoyer un email de rappel pour participer au tournoi au joueur <b v-if="joueurSelected!=null">{{joueurSelected.nom}} {{joueurSelected.prenom}}</b> ?
        </s-confirm>
        
        <s-info
            :open="modalMailSended"
            title="Mail envoyé"
            @close="modalMailSended=false"
            :close="true"
            v-if="joueurSelected!=null" 
            id="askSendEmailOnePlayer"
        >
            Une demande de participation a été envoyé au joueur à {{joueurSelected.prenom}} à {{joueurSelected.nom}}
        </s-info>
        
        <s-modal
            :open="modalConfigure"
            :cancel="true"
            @cancel="modalConfigure=false"
            :save="true"
            @save="saveParameterSend"
        >
         <div>
                Les joueurs peuvent s'inscire :
                    <s-button icon="" label="OUI" 
                            :theme="subscribe ? 'is-success is-small' : 'is-light is-small'" 
                            @onclick="setSubcribe()"
                            :disabled="club.demo"
                            />&nbsp;
                <s-button icon="" label="NON" 
                    :theme="!subscribe ? 'is-danger is-small' : 'is-light is-small'"
                    @onclick="setSubcribe()"
                    :disabled="club.demo" />
                <br/><br/>
            </div>
            <div v-if="subscribe">
            <label>Les joueurs doivent s'incrire &nbsp;</label>
            <input type="number" class="input is-primary is-small" style="width: 100px" v-model="delaiEmail"/> heures avant le début du tournoi
            <div>
                <s-l id="joueursInscrireEmail" :v="dateDelai.toLocaleString('fr-FR')">Les joueur doivent s'incrire avant le %v</s-l>
            </div>
            <hr/>
                <div>
                Les joueurs peuvent se désinscrire :
                    <s-button icon="" label="OUI" 
                            :theme="unsubscribe ? 'is-success is-small' : 'is-light is-small'" 
                            @onclick="setUnscribe()"
                            :disabled="club.demo"
                            />&nbsp;
                <s-button icon="" label="NON" 
                    :theme="!unsubscribe ? 'is-danger is-small' : 'is-light is-small'"
                    @onclick="setUnscribe()"
                    :disabled="club.demo" />
                   <br/><br/>
            </div>
                <div v-if="unsubscribe">
                <label>Les joueurs peuvent se désinscire avant &nbsp;</label>
                <input type="number" class="input is-primary is-small" style="width: 100px" v-model="delaiEmailUnscribe"/> heures avant le début du tournoi
                <div>
                    <s-l id="joueursInscrireEmail" :v="dateDelaiUnscribe.toLocaleString('fr-FR')">Les joueur doivent s'incrire avant le %v</s-l>
                </div>
            </div>
            <div style="text-align:right">
                <s-button v-if="this.subscribe" label="Envoyer un mail de rappel" @onclick="modalConfigure=false;modalConfirmMailALL=true" theme="is-primary" />
            </div>
            </div>
        </s-modal>
        <s-modal
            :open="modalMailsSended"
            :cancel="true"
            @cancel="modalMailsSended=false"
        >
            Une demande de participation a été envoyé aux joueurs :
            <div v-for="joueur in joueursSended">
                {{joueur}}
            </div>
        </s-modal>
        <s-confirm
            :open="modalConfirmMailALL"
            @no="modalConfirmMailALL=false"
            @yes="sendMailALL()"
        >
            Souhaitez vous envoyer un email de rappel aux joueurs qui n'ont pas encore répondu ? ?
        </s-confirm>
    </s-modal>
</template>
<style scoped>
    .buttonReinit {
        margin-top: 10px;
        margin-left: auto;
        margin-right: auto;
        text-align: center;
        width: 70%;
        font-weight: bolder;
    }
    .ligne {
        margin: 5px;
        text-align: center;
       
    }
    .nomprenom {
        width: 150px;
        padding: 2px;
        display: inline-block;
        vertical-align: middle;
        text-overflow: ellipsis; 
    }
    .email {
        width: 220px;
        padding: 2px;
        display: inline-block;
        overflow: hidden;
        text-overflow: ellipsis; 
    }
     .state {
        width: 100px;
        padding: 2px;
        display: inline-block;
    }
    .rappel {
        width: 50px;
        padding: 2px;
        display: inline-block;
    }
    .pasEmail {
        background-color: gray;
    }
    .waiting {
        background-color: rgb(221, 220, 177);
        vertical-align: middle;
    }
    .absent {
        background-color: red;
        color: white;
    }
    .confirmed {
        background-color: green;
        color: white;
    }
    .listMembresState {
        height: 300px;
        overflow-y: auto;
    }
</style>
<script>
import mail_fct from "@/firebase/mails"
import firebase_api from "@/firebase/firebase_api"
export default ({
    props: ['tournoi','open', 'joueurs', 'club'],
    watch: {
        nbReponseAbsent(val) {
            this.refresh();
        },
        nbReponseConfirmed(val) {
            this.refresh();
        },
        open() {
            this.refresh();
        }
    },

    computed: {
        dateDelai: {
            get() {
                return this.$dateLimit(this.tournoi.date, this.tournoi.heure, this.delaiEmail);
            }
        },
        dateDelaiUnscribe: {
            get() {
                return this.$dateLimit(this.tournoi.date, this.tournoi.heure, this.delaiEmailUnscribe);
            }
        },
        nbReponseAbsent: {
            get() {
                var nb=0;
                if (typeof(this.tournoi.absents)!="undefined")
                    nb = this.tournoi.absents.length;
                return nb;
            }
        },
        nbReponseConfirmed: {
            get() {
                var nb=0;
                if (typeof(this.tournoi.confirmed)!="undefined")
                    nb = this.tournoi.confirmed.length;
                return nb;
            }
        }
    },
    data() {
        return {
            modalConfirmMailALL: false,
            joueursSortedByEmail: [],
            modalConfirmMail: false,
            joueurSelected: null,
            modalMailSended: false,
            modalConfigure: false,
            delaiEmail: 0,
            delaiEmailUnscribe: 0,
            unsubscribe: false,
            subscribe: false,
            joueursSended:[],
            modalMailsSended : false
        }
    },

    mounted() {

        this.refresh();
    },
    methods: {
        setUnscribe() {
            this.unsubscribe = !this.unsubscribe;
        },
        setSubcribe() {
            this.subscribe = !this.subscribe;
        },
        sendMail(joueur, msg) {
            var dateTournoi = new Date(this.tournoi.date);
           
            var email = (joueur.email=='' || joueur.email==null) ? joueur.emailParent : joueur.email;
            var dateDelai =  this.$dateLimit(dateTournoi, this.tournoi.heure, this.tournoi.options.delaiEmail);
            var params= {
                club: this.club.name,
                idClub: this.club.id,
                url: window.location.origin + '/participeTournoi',
                tournoiDate: dateTournoi.toLocaleString('fr-FR', {dateStyle: 'short'}) + ' à ' + this.tournoi.heure,
                email: email,
                dateLimit: dateDelai.toLocaleString('fr-FR'),
                idTournoi: this.tournoi.id
            }
           
            var idMail = "TOURNOI_CREER";
            if (!this.tournoi.options.subscribe)
                idMail = "TOURNOI_CREER_SANS_LIEN";
            mail_fct.object.sendEmail(email, idMail, params);
            this.modalConfirmMail = false;
            this.modalMailSended = msg;
        },
        sendMailALL() {
            this.joueursSended = [];
            this.joueursSortedByEmail.forEach((joueur, indiceJoueur)=>{
                if (this.joueurClass(joueur)=="waiting") {
                    this.joueursSended.push(joueur.nom + " "+joueur.prenom);
                    this.sendMail(joueur, false);
                }
                if (indiceJoueur==this.joueursSortedByEmail.length-1) {
                    this.modalConfirmMailALL = false;
                    this.modalMailsSended = true;
                }

            })
        },
        presinscriptionReinit() {
            this.tournoi.joueurs = [];
            this.tournoi.preinscription = [];
            this.joueursSortedByEmail.forEach(joueur=>{
                if (joueur.confirmed)
                    this.tournoi.preinscription.push(joueur.id);
            })
            firebase_api.api.getDb().collection("club").doc(this.club.id)
                .collection("tournois").doc(this.tournoi.id).update({
                    preinscription: this.tournoi.preinscription,
                    joueurs: []
                }).then(doc=>{
                    this.$emit('close');
                })
            
        },
        joueurClass(joueur) {
            var classReturn = '';
           
            if (typeof(joueur.emailParent)!="undefined") {
                 if (joueur.emailParent == '' || joueur.emailParent == null) {
                     classReturn = "pasEmail";
                 }
            }
            else if (joueur.email == '' || joueur.email == null) {
                classReturn = "pasEmail";
            }
            if (classReturn == '') {
                if (joueur.absent)
                    classReturn = "absent";
                else if (joueur.confirmed)
                    classReturn = "confirmed";
                else
                    classReturn = 'waiting';
            }
            return classReturn;
        },
        saveParameterSend() {
            this.tournoi.options.unsubscribe = this.unsubscribe;
            this.tournoi.options.subscribe = this.subscribe;
            this.tournoi.options.delaiEmail = this.delaiEmail;
            this.tournoi.options.delaiEmailUnscribe = this.delaiEmailUnscribe;
            firebase_api.api.getDb().collection("club").doc(this.club.id).collection("tournois").doc(this.tournoi.id).update({
                "options.unsubscribe": this.unsubscribe,
                "options.subscribe": this.subscribe,
                "options.delaiEmail": this.delaiEmail,
                "options.delaiEmailUnscribe": this.delaiEmailUnscribe,
            })
            this.modalConfigure=false;
        },
        refresh() {
           
            this.subscribe = this.tournoi.options.subscribe;
            this.unsubscribe = this.tournoi.options.unsubscribe;
            this.delaiEmail = this.tournoi.options.delaiEmail;
            this.delaiEmailUnscribe = this.tournoi.options.delaiEmailUnscribe;
            this.joueursSortedByEmail = [];
           if (typeof(this.joueurs)!="undefined") {
                var alljoueurs = JSON.parse(JSON.stringify(this.joueurs));
            
                var joueurWithEmail = [];
                var joueurWithoutEmail = [];
                alljoueurs.forEach(joueur => {
                    if ((joueur.email != null && joueur.email != '') || (joueur.emailParent != null && joueur.emailParent != '')) {
                        if (typeof(this.tournoi.absents)!="undefined")
                            if (this.tournoi.absents.findIndex(elt=>elt === joueur.id) != -1)
                                joueur.absent = true;
                            else
                                joueur.absent = false;
                        
                        if (typeof(this.tournoi.confirmed)!="undefined")
                            if (this.tournoi.confirmed.findIndex(elt=>elt === joueur.id) != -1)
                                joueur.confirmed = true;
                            else
                                joueur.confirmed = false;
                        joueurWithEmail.push(joueur);
                    }
                    else {
                        joueurWithoutEmail.push(joueur);
                    }
                });
                joueurWithEmail.sort((a,b)=>{
                    return a.nom.toUpperCase() > b.nom.toUpperCase() ? 1 : -1
                })
                joueurWithoutEmail.sort((a,b)=>{
                    return a.nom.toUpperCase() > b.nom.toUpperCase() ? 1 : -1
                })
                joueurWithEmail.forEach(joueur=>{
                    this.joueursSortedByEmail.push(joueur);
                })
                joueurWithoutEmail.forEach(joueur=>{
                    this.joueursSortedByEmail.push(joueur);
                })
           }
        }
    }
})
</script>
